import React from "react";
import { useHardPromotionFormMutate } from "../contexts/hard-promotion-form.context";
import { Button, InputNumber, Popconfirm, Table } from "antd";
import { displayTotal } from "../../../../../utils/helper";
import { FaTrashAlt } from "react-icons/fa";

const TYPE = "items";
const TableItems = () => {
  const {
    state: { loading, data },
    dispatch,
  } = useHardPromotionFormMutate();

  const handleDelItems = (product_code) => {
    dispatch({ type: "DEL_ITEM", payload: { type: TYPE, product_code } });
  };

  const isItemCondition = data?.condition_type === "item";

  return (
    <Table
      size="small"
      bordered
      loading={loading}
      dataSource={data[TYPE] || []}
      rowKey="product_code"
      pagination={{
        size: "default",
        showLessItems: true,
        showTotal: displayTotal,
      }}
    >
      <Table.Column
        key="product_code"
        title="รหัสสินค้า"
        dataIndex="product_code"
        align="center"
      />
      <Table.Column
        key="product_name"
        title="ชื่อสินค้า"
        dataIndex="product_name"
      />
      <Table.Column
        key="qty"
        title="จำนวนสินค้า"
        dataIndex="qty"
        align="right"
        render={(text, { product_code }) => {
          return (
            <InputNumber
              size="small"
              value={isItemCondition ? text : 1}
              disabled={!isItemCondition}
              min={1}
              step={1}
              onChange={(value) =>
                dispatch({
                  type: "SET_ITEM",
                  payload: {
                    type: TYPE,
                    product_code,
                    value: { qty: value },
                  },
                })
              }
              onBlur={(e) => {
                const value = e.target.value;
                if (value === "") {
                  dispatch({
                    type: "SET_ITEM",
                    payload: {
                      type: TYPE,
                      product_code,
                      value: { qty: 1 },
                    },
                  });
                }
              }}
              style={{ maxWidth: "100px" }}
            />
          );
        }}
      />
      <Table.Column
        key="action"
        dataIndex="product_code"
        align="center"
        render={(text) => (
          <Popconfirm
            title={`ต้องการลบ ${text} ออกจากรายการหรือไม่`}
            okText="ลบ"
            cancelText="ปิด"
            onConfirm={() => handleDelItems(text)}
            okType="danger"
          >
            <Button size="small" type="danger">
              <FaTrashAlt />
            </Button>
          </Popconfirm>
        )}
      />
    </Table>
  );
};

export default TableItems;
